var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.779 19.85a1.52 1.52 0 0 1-1.112-.47 1.521 1.521 0 0 1-.472-1.113V5.734c0-.427.157-.798.472-1.112a1.52 1.52 0 0 1 1.112-.472h12.537c.418 0 .786.157 1.104.472.317.314.475.685.475 1.112v5.1L21.13 7.6a.38.38 0 0 1 .433-.09c.167.063.25.182.25.357v8.27c0 .172-.083.29-.25.352a.379.379 0 0 1-.433-.089l-3.234-3.233v5.1c0 .427-.158.798-.475 1.112-.318.314-.686.471-1.104.471H3.779Zm0-1.583h12.533V5.734H3.78v12.533Z"
  })));
};
export default SvgVideo;